export const mergeTranslationsWithSurvey = (surveyDefinition, translations) => {
   
    if (!surveyDefinition || !translations) return surveyDefinition;
    
    const mergedSurvey = JSON.parse(JSON.stringify(surveyDefinition));
    const translationPages = translations.pages || [];

    mergedSurvey.pages.forEach(page => {
        page.elements.forEach(question => {
            const translation = translationPages.find(t => 
                t.id === question.id || t.tempId === question.tempId
            );
            
            if (translation?.translations) {
                // Merge question-level translations
                question.translations = {
                    ...question.translations,
                    ...translation.translations
                };

                // Handle choices translations for all question types
                if (question.choices) {
                    // Case 1: Choices is array of strings (['test,test1,test3'])
                    if (typeof question.choices[0] === 'string') {
                        const choicesArray = question.choices[0].split(',').map(item => item.trim());
                        question.choices = choicesArray.map((choice, index) => {
                            const choiceTranslations = {};
                            
                            Object.entries(translation.translations).forEach(([lang, trans]) => {
                                if (trans.choices?.[index]) {
                                    choiceTranslations[lang] = { 
                                        text: typeof trans.choices[index] === 'string' 
                                            ? trans.choices[index] 
                                            : trans.choices[index].text || trans.choices[index].value
                                    };
                                }
                            });

                            return {
                                id: "",
                                tempId: index + 1,
                                text: choice,
                                value: choice,
                                ...(Object.keys(choiceTranslations).length > 0 && { 
                                    translations: choiceTranslations 
                                })
                            };
                        });
                    }
                    // Case 2: Choices is array of objects
                    else {
                        question.choices.forEach(choice => {
                            // Skip empty choices (like in open text questions)
                            if (!choice.id && !choice.text && !choice.value) return;
                            
                            const choiceTranslations = {};
                            
                            Object.entries(translation.translations).forEach(([lang, trans]) => {
                                // Find matching translation by tempId, text, or value
                                const translatedChoice = trans.choices?.find(c => 
                                    c.tempId === choice.tempId || 
                                    c.value === choice.value ||
                                    c.text === choice.text
                                );
                                
                                if (translatedChoice) {
                                    choiceTranslations[lang] = { 
                                        text: typeof translatedChoice === 'string' 
                                            ? translatedChoice 
                                            : translatedChoice.text || translatedChoice.value
                                    };
                                }
                            });

                            if (Object.keys(choiceTranslations).length > 0) {
                                choice.translations = {
                                    ...choice.translations,
                                    ...choiceTranslations
                                };
                            }
                        });
                    }
                }

                // Handle matrix rows translations
              if (question.rows) {
                    question.rowTranslations = question.rows.map((row, index) => {
                        return Object.entries(translation.translations).reduce((acc, [lang, trans]) => {
                            acc[lang] = { 
                                text: trans.rows?.[index] || row 
                            };
                            return acc;
                        }, {});
                    });
                }

                // 4. Handle columns with defaults
                if (question.columns) {
                    question.columnTranslations = question.columns.map((col, index) => {
                        return Object.entries(translation.translations).reduce((acc, [lang, trans]) => {
                            acc[lang] = { 
                                text: trans.columns?.[index] || col 
                            };
                            return acc;
                        }, {});
                    });
                }
            }
        });
    });
    //console.log(mergedSurvey, "mergedSurvey after merging translations");
    return mergedSurvey;
};